import {
    SET_WORKS,
    SET_EDIT_WORK,
    SET_NEW_WORK,
    SET_DELETE_WORK,
    SET_DELETE_MULTI_WORK,
    SET_LIST_WORKS,
    SET_WORK,
    RESET_ITEMS_WORK,
    RESET_LIST_WORKS,
    RESET_SELECTED_WORK,
    SET_REPEATED_WORKS,
    RESET_REPEATED_WORKS,
    SET_DELETE_REPEATED_WORK,
    SET_DELETE_REPEATED_MULTI_WORK,
} from "redux/constants/Works";

const initalAgreementState = {
    items: [],
    list: [],
    selected: {},
    repeated: [],
    loading: true,
};
const Works = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_WORKS: {
            return { ...state, items: payload, loading: false };
        }
        case SET_LIST_WORKS: {
            return { ...state, list: payload };
        }
        case SET_REPEATED_WORKS: {
            return { ...state, repeated: payload, loading: false };
        }
        case SET_WORK: {
            return { ...state, selected: payload };
        }
        case SET_NEW_WORK: {
            // return { ...state, items: [payload, ...state.items] };
            return state;
        }

        case SET_EDIT_WORK: {
            let list = [...state.items];

            try {
                let ind = list.findIndex((item) => item._id === payload._id);

                if (ind > -1) {
                    list[ind] = payload;
                }
            } catch (error) {}

            return { ...state, items: list };
        }

        case SET_DELETE_WORK: {
            let list = state.items.filter((item) => item._id !== payload);

            return { ...state, items: list };
        }

        case SET_DELETE_MULTI_WORK: {
            let arr = payload.split(",");
            let list = state.items.filter((item) => !arr.includes(item._id));

            return { ...state, items: list };
        }

        case SET_DELETE_REPEATED_WORK: {
            let list = state.repeated.filter((item) => item._id !== payload);

            return { ...state, repeated: list };
        }

        case SET_DELETE_REPEATED_MULTI_WORK: {
            let arr = payload.split(",");
            let list = state.repeated.filter((item) => !arr.includes(item._id));

            return { ...state, repeated: list };
        }
        case RESET_LIST_WORKS: {
            return { ...state, list: [], loading: true };
        }
        case RESET_REPEATED_WORKS: {
            return { ...state, repeated: [], loading: true };
        }
        case RESET_SELECTED_WORK: {
            return { ...state, selected: {}, loading: true };
        }

        case RESET_ITEMS_WORK: {
            return { ...state, items: [], loading: true };
        }

        default:
            return state;
    }
};

export default Works;
